var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { id: "store_detail_nav", cols: "2" } },
    [
      _c(
        "v-row",
        {
          staticClass: "ma-0 pa-3 pt-5 pb-5",
          attrs: { justify: "space-between", align: "center" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              staticStyle: { "text-align": "start" },
              attrs: { cols: "10", "align-self": "center" },
            },
            [_vm._v(" " + _vm._s(_vm.storeName) + " ")]
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0 pb-10" },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
            [
              _c(
                "v-list",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { dense: "", id: "nav_list" },
                },
                [
                  _vm._l(_vm.navItems, function (item, index) {
                    return [
                      _c(
                        "v-list-item",
                        { key: item.name, staticClass: "ma-0 pa-0" },
                        [
                          _c(
                            "v-list-item-content",
                            {
                              staticClass: "ma-0 pa-3 pt-2 pb-2 pr-1",
                              class: {
                                current_route: _vm.currentRoute == item.name,
                              },
                              attrs: { align: "left", id: "menu_item" },
                              on: {
                                click: function ($event) {
                                  return _vm.goPush(item.path)
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-title",
                                { staticStyle: { "font-size": "0.8rem" } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-1 pl-3",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _c("v-img", {
                                            staticClass: "ma-0 pa-0 mr-2",
                                            attrs: {
                                              "max-height": "1.25rem",
                                              "max-width": "1rem",
                                              src: require("@/assets/images/" +
                                                item.icon +
                                                ".png"),
                                            },
                                          }),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "auto" },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.name) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      index == 3
                                        ? _c("v-img", {
                                            staticClass: "ma-0 pa-0 mr-2",
                                            attrs: {
                                              "max-height": "1.5rem",
                                              "max-width": "1.25rem",
                                              src: require("@/assets/images/plus_round.png"),
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "ma-0 pa-0 pt-15 pl-3 pr-3",
          attrs: { justify: "center" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              attrs: { id: "camera_box", cols: "12" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-2",
                  attrs: { justify: "space-around" },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "5" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { id: "camera_text_big", justify: "center" },
                        },
                        [_vm._v(_vm._s(_vm.cameraCount.uas))]
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { id: "camera_text_small", justify: "center" },
                        },
                        [_vm._v(_vm._s(_vm.tsc("AiCamera")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { cols: "auto", "align-self": "center" },
                    },
                    [
                      _c("v-divider", {
                        attrs: { id: "camera_divider", vertical: "" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "5" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { id: "camera_text_big", justify: "center" },
                        },
                        [_vm._v(_vm._s(_vm.cameraCount.uac))]
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { id: "camera_text_small", justify: "center" },
                        },
                        [_vm._v(_vm._s(_vm.tsc("cctvCamera")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "ma-0 pa-3 pt-15 pb-5",
          attrs: { id: "info_text_small" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              attrs: { cols: "auto", id: "info_text_right" },
            },
            [_vm._v(" " + _vm._s(_vm.tsc("address")) + " : ")]
          ),
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              attrs: { cols: "auto", id: "info_text_left" },
            },
            [
              _vm._v(" " + _vm._s(_vm.storeData.customerAddress1) + " "),
              _c("br"),
              _vm._v(" " + _vm._s(_vm.storeData.customerAddress2) + " "),
              _c("br"),
              _vm._v(" " + _vm._s(_vm.storeData.customerAddress3) + " "),
            ]
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "ma-0 pa-0 pl-3 pr-3 pb-2",
          attrs: { id: "info_text_small" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              attrs: { cols: "auto", id: "info_text_right" },
            },
            [_vm._v(" " + _vm._s(_vm.tsc("phone")) + " : ")]
          ),
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              attrs: { cols: "auto", id: "info_text_left" },
            },
            [_vm._v(" " + _vm._s(_vm.storeData.customerTel) + " ")]
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "ma-0 pa-0 pl-3 pr-3",
          attrs: { id: "info_text_small" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              attrs: { cols: "auto", id: "info_text_right" },
            },
            [_vm._v(" " + _vm._s(_vm.tsc("administrator")) + " : ")]
          ),
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0",
              attrs: { cols: "auto", id: "info_text_left" },
            },
            [_vm._v(" " + _vm._s(_vm.storeData.customerName) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }